import { Schema as S } from "effect";
import { Literal } from "effect/Schema";
export const trueFromString = S.transform(Literal("true"), S.Boolean, {
    decode: ()=>true,
    encode: ()=>"true",
    strict: true
});
